import React from 'react';
import BookingList from './BookingList';

/*
 * Cancelled — pembatalan dan booking kedaluwarsa.
 *
 * Lima status digabung: dibatalkan pelanggan, ditolak provider, dibatalkan
 * admin, kedaluwarsa, dan dikembalikan dananya.
 *
 * Gabungan dari DUA sumber yang tidak sepakat. Prototipe menyaring
 * `status.indexOf('cancel') === 0 || status === 'expired'` — tanpa refunded.
 * Layar lama /siteadmin/cancelled-jobs memakai cancel* + refunded — tanpa
 * expired. Mengikuti salah satunya saja membuat sebagian booking tidak muncul
 * di layar mana pun; tiga booking berstatus 'refunded' sempat begitu, dan itu
 * uang yang sudah keluar tanpa satu pun halaman menampilkannya.
 *
 * Disebut satu per satu, bukan pencocokan awalan, karena resolver-nya memakai
 * daftar putih enum.
 *
 * `showReason` menampilkan kolom alasan — layar ini satu-satunya tempat
 * Booking.cancelReason berguna, dan kalimat pembuka client menjanjikannya.
 */
const Cancelled = () => (
  <BookingList
    current="cancelled"
    breadcrumb={['Operations', 'Cancelled']}
    title="Cancelled jobs"
    lead="Cancelled or expired bookings, with the reason recorded."
    slug="cancelled"
    statuses="cancelledByUser,cancelledByPartner,cancelledByAdmin,expired,refunded"
    legacyHref="/siteadmin/cancelled-jobs"
    showReason
    emptyTitle="Nothing cancelled"
    emptyMsg="Cancelled and expired bookings appear here."
  />
);

export default Cancelled;
